<div class="w-full flex gap-4 p-8 bg-card flex-col">
  <!-- Gráfica donut -->
    <div class="w-full flex gap-4">
        <div class="w-full md:w-8/12">
        <div class="rounded-2xl border border-gray-200 p-6">
        <div class="text-lg font-semibold text-gray-800 mb-4">
            Relación según tipo de Profesión
        </div>

        <div class="w-full" *ngIf="professionChartOptions.series?.length">
            <apx-chart
            [series]="professionChartOptions.series"
            [chart]="professionChartOptions.chart"
            [labels]="professionChartOptions.labels"
            [legend]="professionChartOptions.legend"
            [responsive]="professionChartOptions.responsive"
            [stroke]="professionChartOptions.stroke"
            [dataLabels]="professionChartOptions.dataLabels"
            [fill]="professionChartOptions.fill"
            [plotOptions]="professionChartOptions.plotOptions"
            [colors]="professionChartOptions.colors"
            ></apx-chart>
        </div>
        </div>



    </div>

    <div
            class="flex flex-col w-full md:flex-1 gap-4"
            *ngIf="datosEstadisticos"
        >
            <counter-card
            [value]="datosEstadisticos?.contadores.totalArea"
            label="Total de Áreas Generales"
            bgClass="bg-primary-50"
            textClass="text-primary-800"
            ></counter-card>

            <counter-card
            [value]="datosEstadisticos?.contadores.totalSubarea"
            label="Total de Sub Área o Asignaturas"
            bgClass="bg-red-50"
            textClass="text-red-800"
            ></counter-card>

            <counter-card
            [value]="datosEstadisticos?.contadores.totalCarrerasDiversificado"
            label="Total de Registros de Diversificado"
            bgClass="bg-indigo-50"
            textClass="text-indigo-800"
            ></counter-card>

        </div>
    </div>


    <!-- Tabla de registros recientes -->
    <div class="mt-4 rounded-2xl border border-gray-200 p-6 bg-card">
      <div class="text-lg font-semibold text-gray-800 mb-4">
        Registros recientes
      </div>

      <mat-tab-group class="mt-2" [selectedIndex]="tabIndex" (selectedIndexChange)="onTabChange($event)"
        mat-stretch-tabs="false"
        mat-align-tabs="start">
        <mat-tab label="Básico"></mat-tab>
        <mat-tab label="Diversificado"></mat-tab>
      </mat-tab-group>

      @if(!cargandoRegistros){
        <div class="mt-4">
          <app-tabla-registros
            [registros]="registros"
            [esBasico]="cicloSeleccionado !== cicloDiversificado"
            (eliminarRegistro)="eliminarRegistro($event)"
            (publicarRegistro)="publicarRegistro($event)"
          ></app-tabla-registros>
        </div>
      }
    </div>


</div>
